import ical, {ICalCalendar, ICalCalendarMethod} from 'ical-generator';
import {DateTime, Interval} from "luxon";
import {inject, singleton} from "tsyringe";
import {ISSUE_TYPE_MILESTONE} from "../constants";
import {IssueRepository} from "../domain/repositories/issue.repository";
import {StringHelper} from "../helpers/string.helper";

@singleton()
export class ICalExporterService {

    constructor(
        @inject(IssueRepository) private readonly _issueRepository: IssueRepository
    ) {
    }

    public async export(name: string, interval: Interval): Promise<ICalCalendar> {
        const timeFrames = await this._issueRepository.findAllByIntervalAndIssueType(interval, ISSUE_TYPE_MILESTONE, [`project`]);

        return ical({
            name,
            description: `Stand vom ${DateTime.now().toLocaleString()}`,
            source: `Horstplan`,
            method: ICalCalendarMethod.REQUEST,
            prodId: `//horstplan.de//ical-generator//DE`,
            timezone: DateTime.local().zoneName,
            events: timeFrames.map(timeFrame => {
                return {
                    start: timeFrame.start.setZone(DateTime.local().zone, {keepLocalTime: true}).toJSDate(),
                    end: timeFrame.end.setZone(DateTime.local().zone, {keepLocalTime: true}).toJSDate(),
                    summary: timeFrame.project?.title ?? `ohne Titel`,
                    description: timeFrame.project?.description ?? `ohne Beschreibung`,
                    url: timeFrame.project?.url ?? ``
                };
            })
        });
    }

    public async exportAsDownload(name: string, interval: Interval): Promise<void> {
        const calendar = await this.export(name, interval);
        const blob = new Blob([calendar.toString()], {type: "text/calendar"});

        // Öffne einen Download-Dialog
        const anchor = document.createElement("a");
        anchor.href = URL.createObjectURL(blob);
        anchor.download = `${StringHelper.toKebabCase(name)}-${interval.toISODate()}.ics`;
        anchor.click();
    }
}